import { createAction, props } from "@ngrx/store";

export const pcpAiLoggerInitialized = createAction(
    '[PcpInsightsLogger]: initialized'
);
